interface HeaderProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
}

function Header({ title, children }: HeaderProps) {
  return (
    <header className="p-4 md:p-0 md:pr-4">
      <div
        className={`mx-auto flex items-center ${title ? 'justify-between' : 'justify-end'} gap-4 md:justify-between`}
      >
        {title && <div className="flex items-center">{title}</div>}
        {children}
      </div>
    </header>
  );
}

export default Header;
